import { render, staticRenderFns } from "./VIndex.vue?vue&type=template&id=56d17c8e&"
import script from "./VIndex.vue?vue&type=script&lang=js&"
export * from "./VIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports